package com.nnod.landing.web

import com.nnod.landing.nodin.NodInLandingKind

sealed interface LandingRoute {
    data class NodIn(
        val kind: NodInLandingKind,
        val idolName: String,
        val campaignId: String,
        val eventName: String,
        val scheduledTime: String,
        val displayCode: String,
    ) : LandingRoute

    data object NotFound : LandingRoute
}

fun parseLandingRoute(path: String): LandingRoute {
    val cleanPath = path.substringBefore("?").trimEnd('/')
    val segments = cleanPath.split('/').filter { it.isNotBlank() }
    if (segments.size != 7 || segments[0] != "nodin") return LandingRoute.NotFound

    val kind = when (segments[1]) {
        "s" -> NodInLandingKind.START
        "e" -> NodInLandingKind.END
        else -> return LandingRoute.NotFound
    }
    val idolName = decodeRouteSegmentOrNull(segments[2]) ?: return LandingRoute.NotFound
    val campaignId = decodeRouteSegmentOrNull(segments[3]) ?: return LandingRoute.NotFound
    val eventName = decodeRouteSegmentOrNull(segments[4]) ?: return LandingRoute.NotFound
    val scheduledTime = decodeRouteSegmentOrNull(segments[5]) ?: return LandingRoute.NotFound
    val displayCode = decodeRouteSegmentOrNull(segments[6]) ?: return LandingRoute.NotFound
    if (
        idolName.isBlank() ||
        campaignId.isBlank() ||
        eventName.isBlank() ||
        scheduledTime.isBlank() ||
        displayCode.isBlank()
    ) {
        return LandingRoute.NotFound
    }

    return LandingRoute.NodIn(
        kind = kind,
        idolName = idolName,
        campaignId = campaignId,
        eventName = eventName,
        scheduledTime = scheduledTime,
        displayCode = displayCode,
    )
}

expect fun getBrowserPathname(): String

expect fun openDeepLink(url: String)

expect fun copyToClipboard(text: String)
